/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    ROAM_PLANS_RECEIVE,
    ROAM_PLANS_REQUEST,
    ROAM_PLANS_REQUEST_SUCCESS,
    ROAM_PLANS_REQUEST_FAILURE,
    CURRENT_ROAM_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [ROAM_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [ROAM_PLANS_REQUEST]: () => true,
    [ROAM_PLANS_REQUEST_SUCCESS]: () => false,
    [ROAM_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [ROAM_PLANS_REQUEST]: () => false,
    [ROAM_PLANS_REQUEST_SUCCESS]: () => false,
    [ROAM_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
